import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { IPropertyListFilterSchema } from "../pages/list/util/propertyListFilter";
import HCheckArray from "@rf-helper/check-have-value";

const convertPropertyListAdapter = (values: IPropertyListFilterSchema) => {
  return {
    city: HCheckArray(values.city)
      ? values.city.map(x => x.value).join(",")
      : undefined,
    sector: HCheckArray(values.sector)
      ? values.sector.map(x => x.value).join(",")
      : undefined,
    parkings: HCheckArray(values.parking)
      ? values.parking.map(x => x).join(",")
      : undefined,
    bedrooms: HCheckArray(values.bedroom)
      ? values.bedroom.map(x => x).join(",")
      : undefined,
    bathrooms: HCheckArray(values.bathroom)
      ? values.bathroom.map(x => x).join(",")
      : undefined,
    halfBathrooms: HCheckArray(values.halfBathroom)
      ? values.halfBathroom.map(x => x).join(",")
      : undefined,
    floorLevels: HCheckArray(values.levelFloor)
      ? values.levelFloor.map(x => x).join(",")
      : undefined,
    price: prepareFiltersTypeRangePrice(
      values?.priceMin,
      values?.priceMax,
      values?.currencySale
    ),
    maintenancePrice: prepareFiltersTypeRangePrice(
      values?.maintenanceMin,
      values?.maintenanceMax,
      values?.maintenanceCurrency
    ),
    landSize: prepareFiltersTypeRange(values?.metersLandMin, values?.metersLandMax),
    constructionSize: prepareFiltersTypeRange(
      values?.metersConstructionMin,
      values?.metersConstructionMax
    ),
    status: HCheckArray(values.status)
      ? values.status.map(x => x.value).join(",")
      : undefined,
    type: HCheckArray(values.type)
      ? values.type.map(x => x.value).join(",")
      : undefined,
    business: HCheckArray(values.businessType)
      ? values.businessType.map(x => x.value).join(",")
      : undefined,
    extraBusinessTypes: HCheckArray(values.detailType)
      ? values.detailType.map(x => x.id).join(",")
      : undefined,
    improvements: HCheckArray(values.improvements)
      ? values.improvements.map(x => x.id).join(",")
      : undefined,
    condition: HCheckArray(values.condition)
      ? values.condition.map(x => x.id).join(",")
      : undefined,
    agency: HCheckArray(values.agencies)
      ? values.agencies.map(x => x.id).join(",")
      : undefined,
    agent: HCheckArray(values.agents)
      ? values.agents.map(x => x.id).join(",")
      : undefined,
    masterBroker: values.masterBroker ? values.masterBroker : undefined,
    trust_entity: HCheckArray(values.fideicomiso)
      ? values.fideicomiso.map(x => x.id).join(",")
      : undefined,
    search: values.search ? values.search : undefined,
    page: values.page,
    own: values.myProperties ? values.myProperties : undefined,
    commission: values?.percentCommission
      ? `>=${values?.percentCommission}`
      : undefined,

    feature: HCheckArray(values.improvements)
      ? values.improvements.map(x => x.value).join(",")
      : undefined,
    ...prepareOrderBy(values.orderBy as I_GENERIC_ITEMS<any>[]),
    // delivers:  values.delivers,
    collection: values.isCollection ? values.isCollection : undefined,
    area: values.area ? values.area : undefined,
    createdAt: values.createdAt ? values.createdAt : undefined

    //@ts-ignore
  };
};
export default convertPropertyListAdapter;

const prepareOrderBy = (orderBy: I_GENERIC_ITEMS<any>[]) => {
  if (HCheckArray(orderBy)) {
    switch (orderBy[0].value) {
      case "-asc":
        return {
          sort: undefined,
          direction: "asc"
        };
      case "city-desc":
        return {
          sort: "city",
          direction: "desc"
        };
      case "sector-desc":
        return {
          sort: "sector",
          direction: "desc"
        };
      case "price-asc":
        return {
          sort: "price",
          direction: "asc"
        };
      case "price-desc":
        return {
          sort: "price",
          direction: "desc"
        };
    }
  }
  return {
    sort: undefined,
    direction: undefined
  };
};

const prepareFiltersTypeRangePrice = (min: string, max: string, currency: any[]) => {
  const currencyState = HCheckArray(currency)
    ? currency.map(x => x.value).join(",")
    : undefined;
  const range = prepareFiltersTypeRange(min, max);
  if (range) {
    return range + "," + currencyState;
  }
  return undefined;
};

const prepareFiltersTypeRange = (min: string, max: string) => {
  if (min && !max) {
    return `>=${min}`;
  }
  if (!min && max) {
    return `<=${max}`;
  }
  if (min && max) {
    return `${min}...${max}`;
  }
  return undefined;
};
